import store from "./index";
import { deepCopy } from "@/utils/utils";
import eventBus from "@/utils/eventBus";

/** 限制撤销栈长度，避免组件极多时 deepCopy 占满内存、操作越来越卡（不改变对外保存的数据结构） */
const MAX_SNAPSHOT_COUNT = 50;

export default {
  state: {
    snapshotData: [], // 编辑器快照数据
    snapshotIndex: -1, // 快照索引
  },
  mutations: {
    undo(state) {
      // 需考虑页面切换的情况
      if (state.snapshotIndex >= 1) {
        state.snapshotIndex--;
        const componentData =
          deepCopy(state.snapshotData[state.snapshotIndex]) || [];
        if (state.curComponent) {
          // 如果当前组件不在 componentData 中，则置空
          let needClean = !componentData.find(
            (component) => state.curComponent.id === component.id
          );

          if (needClean) {
            store.commit("setCurComponent", {
              component: null,
              index: null,
            });
          }
        } else {
          eventBus.$emit('hideArea')
        }
        store.commit("setComponentData", componentData);
        state.isCut = false;
      }
    },

    redo(state) {
      if (state.snapshotIndex < state.snapshotData.length - 1) {
        state.snapshotIndex++;
        store.commit(
          "setComponentData",
          deepCopy(state.snapshotData[state.snapshotIndex])
        );
        state.isCut = false;
      }
    },
    clearSnap(state) {
      state.snapshotIndex = -1;
      state.snapshotData = [];
    },
    recordSnapshot(state) {
      // 添加新的快照(存储上页面id，避免切换页面数据不对)
      var copyDatas = deepCopy(state.componentData);
      if (copyDatas && copyDatas[0]) {
        copyDatas[0].pageId = state.selectedCurrentPage;
      }
      state.snapshotData[++state.snapshotIndex] = copyDatas;
      // 在 undo 过程中，添加新的快照时，要将它后面的快照清理掉
      if (state.snapshotIndex < state.snapshotData.length - 1) {
        state.snapshotData = state.snapshotData.slice(
          0,
          state.snapshotIndex + 1
        );
      }
      while (state.snapshotData.length > MAX_SNAPSHOT_COUNT) {
        state.snapshotData.shift();
        state.snapshotIndex--;
      }
      if (state.snapshotIndex < 0) {
        state.snapshotIndex = 0;
      }
    },
  },
};
